export const environment = {
  production: true,
  urlAngular: "https://bpone.pichincha.com/app",
};
